import MyEditModal from 'components/MyEditModal/MyEditModal';
import inventoryApi from 'features/inventory/inventory.api';
import { InventoryReceipt } from 'features/inventory/models/InventoryReceipt';
import React from 'react';
import { InventoryReceiptEditFields } from '../InventoryReceiptEditFields/InventoryReceiptEditFields';
import './InventoryReceiptEditModal.scss';

export function InventoryReceiptEditModal({
    model,
    onClose,
}: {
    model: InventoryReceipt;
    onClose: () => void;
}) {
    const [saveMutation, saveMutationState] = inventoryApi.useInventoryReceiptUpdateMutation();
    const save = async (editModel: InventoryReceipt) => {
        await saveMutation(editModel).unwrap();
        onClose?.();
    };

    return (
        <MyEditModal
            close={onClose}
            className="InventoryReceiptEditModal"
            title="Edit Inventory Receipt"
            titleContext={model.tuid}
            model={model}
            onSave={save}
            editImmediately={true}
            fullHeight={false}
        >
            {({ editModel, updateField }) => (
                <>
                    <InventoryReceiptEditFields
                        model={editModel}
                        isSaving={saveMutationState.isLoading}
                        updateField={updateField}
                    />
                </>
            )}
        </MyEditModal>
    );
}
